import { render, staticRenderFns } from "./KasaInfo.vue?vue&type=template&id=58606c74&scoped=true"
import script from "./KasaInfo.vue?vue&type=script&lang=ts"
export * from "./KasaInfo.vue?vue&type=script&lang=ts"
import style0 from "./KasaInfo.vue?vue&type=style&index=0&id=58606c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58606c74",
  null
  
)

export default component.exports